import type { PaymentsLedgerTranslations } from "../interfaces/paymentsLedger";

export const paymentsLedgerTranslations: PaymentsLedgerTranslations = {
  page_title: "Libro contable",
  page_subtitle:
    "Asientos de partida doble de cada operación del motor de pagos: reservas, liquidaciones y reversiones",
  refresh_button: "Actualizar",
  refresh_aria: "Actualizar los asientos de la operación",
  live_updated_at: "Actualizado {{time}}",
  why_banner:
    "Cada asiento cuadra débitos contra créditos por moneda: es el mismo invariante que el motor valida al registrarlo. Un asiento descuadrado es un problema del registro, no de esta vista.",

  error_load: "No se pudieron cargar los asientos",
  error_load_detail:
    "El motor de pagos no respondió. No se muestran importes parciales: volvé a intentar para leer el libro completo.",
  error_retry: "Reintentar",

  picker_title: "Operaciones",
  picker_description: "El libro se lee por operación: elegí una o pegá su ID.",
  picker_tab_payouts: "Dispersiones",
  picker_tab_payins: "Recaudos",
  picker_tab_swaps: "Conversiones",
  picker_search_placeholder: "Pegar ID de operación",
  picker_search_hint: "Se abre la operación sea del tipo que sea.",
  picker_search_invalid: "Ese ID no tiene formato válido.",
  picker_search_resolving: "Buscando la operación…",
  picker_search_not_found: "Ese ID no tiene asientos en ningún tipo de operación.",
  picker_search_failed: "No se pudo verificar ese ID. Volvé a intentar.",
  picker_filter_org_label: "Organización",
  picker_filter_all_orgs: "Todas las organizaciones",
  picker_filter_status_label: "Estado",
  picker_filter_all_statuses: "Todos los estados",
  picker_filter_corridor_label: "Corredor",
  picker_filter_all_corridors: "Todos los corredores",
  picker_filter_date_label: "Fecha",
  picker_filter_all_dates: "Cualquier fecha",
  picker_filter_last_days: "Últimos {{days}} días",
  picker_clear: "Limpiar",
  picker_empty_title: "Sin resultados",
  picker_empty_description: "Ninguna operación coincide con los filtros seleccionados.",
  picker_error: "No se pudo cargar la lista de operaciones.",
  picker_open_button: "Operaciones",
  picker_summary: "{{from}}–{{to}} de {{total}}",
  picker_org_unknown: "Organización sin nombre",

  status_swap_created: "Creada",
  status_swap_completed: "Completada",
  status_swap_failed: "Fallida",

  empty_title: "Elegí una operación",
  empty_description:
    "Cada operación del motor de pagos deja su rastro contable acá: qué cuentas se movieron, en qué dirección y con qué saldo quedaron.",

  header_kind_payout: "Dispersión",
  header_kind_payin: "Recaudo",
  header_kind_swap: "Conversión",
  header_operation_id: "ID de operación",
  header_organization: "Organización",
  header_organization_unknown: "No identificada",
  header_created: "Primer asiento",
  header_currencies: "Monedas",
  header_export_csv: "Exportar CSV",
  header_view_operation: "Ver operación",
  header_status_unavailable:
    "No se pudo leer el estado actual de la operación. Los asientos sí son los reales.",
  copy_success: "Copiado",
  copy_aria: "Copiar",

  kpi_entries_label: "Asientos",
  kpi_entries_meta: "En orden de registro",
  kpi_legs_label: "Partidas",
  kpi_legs_meta: "En {{accounts}} cuentas",
  kpi_balance_label: "Partida doble",
  kpi_balance_ok: "Cuadra",
  kpi_balance_broken: "No cuadra",
  kpi_balance_meta: "Débitos = créditos, por moneda",
  kpi_reversals_label: "Reversiones",
  kpi_reversals_meta: "Asientos contrarios que anulan uno previo",
  kpi_reversals_none: "Ninguna",
  totals_debit: "Débitos",
  totals_credit: "Créditos",
  unbalanced_heading: "Hay un asiento que no cuadra",
  unbalanced_text:
    "En al menos una moneda los débitos no igualan los créditos. El motor valida ese cuadre al registrar, así que esto merece revisión con el equipo de plataforma antes de conciliar.",

  entries_title: "Asientos",
  entries_description: "Cada asiento mueve al menos dos cuentas y cuadra por sí mismo.",
  entry_index: "Asiento #{{index}}",
  entry_badge_reversal: "Reversión del asiento #{{index}}",
  entry_badge_reversed: "Revertido por el asiento #{{index}}",
  entry_balanced: "Cuadra",
  entry_unbalanced: "No cuadra",
  entry_id_label: "ID del asiento",
  entry_reason: "Motivo",
  no_entries_title: "Sin asientos todavía",
  no_entries_description:
    "Esta operación no registró movimientos contables. Pasa, por ejemplo, con un recaudo cuyo QR se emitió y nadie pagó: el asiento se escribe cuando el dinero se mueve.",

  entry_payout_reserve: "Causación y reserva de fondos",
  entry_payout_settle: "Liquidación de la dispersión",
  entry_payout_release: "Liberación de fondos",
  entry_payin_detected: "Recaudo recibido (en suspenso)",
  entry_payin_confirmed: "Recaudo acreditado",
  entry_swap: "Conversión entre billeteras",
  entry_coloca_top_up: "Recarga de Coloca a la billetera del cliente",
  entry_coloca_refund: "Reembolso de Coloca a la billetera del cliente",
  entry_reversal: "Reversión",
  entry_generic_payin: "Movimiento de recaudo",
  entry_generic_payout: "Movimiento de dispersión",
  entry_generic_swap: "Movimiento de conversión",
  entry_generic_fee: "Movimiento de comisión",
  entry_generic_adjust: "Ajuste manual",
  entry_generic_reverse: "Reversión",

  th_account: "Cuenta",
  th_debit: "Débito",
  th_credit: "Crédito",
  th_balance_after: "Saldo resultante",
  totals_row_label: "Totales",
  direction_debit: "Débito",
  direction_credit: "Crédito",

  account_cash_at_provider: "Efectivo en proveedor",
  account_cash_at_provider_hint:
    "Dinero que el proveedor del corredor mantiene a nombre de Coloca. Es un activo: sube cuando entra plata y baja cuando se paga.",
  account_client_liability: "Pasivo con el cliente",
  account_client_liability_hint:
    "Lo que Coloca le debe a la organización. Es el espejo contable del saldo de su billetera.",
  account_payout_in_transit: "Dispersiones en tránsito",
  account_payout_in_transit_hint:
    "Plata ya comprometida con un beneficiario y todavía sin liquidar. Se descarga al pagar, fallar o cancelar.",
  account_payin_suspense: "Recaudos en suspenso",
  account_payin_suspense_hint:
    "Plata recibida que aún no se acreditó a ninguna organización. Debe quedar en cero cuando el recaudo se confirma.",
  account_fx_position: "Posición de cambio",
  account_fx_position_hint:
    "Puente entre las dos monedas de una conversión. Su saldo por moneda es la exposición cambiaria de Coloca, con los residuos de redondeo incluidos.",
  account_fee_revenue: "Ingresos por comisiones",
  account_fee_revenue_hint:
    "Lo que Coloca cobró en la operación: comisión del corredor y, si hubo conversión, comisión de cambio.",
  account_provider_cost: "Costo de proveedor",
  account_provider_cost_hint:
    "Lo que el proveedor le cobró a Coloca. Solo se registra cuando el modelo económico del corredor es absorbido.",
  account_tax_payable: "Impuesto por pagar · {{tax}}",
  account_tax_payable_hint:
    "Impuesto cobrado o asumido en la operación que Coloca debe pagar a la autoridad tributaria.",
  account_tax_expense: "Gasto de impuesto · {{tax}}",
  account_tax_expense_hint: "Impuesto que Coloca asume en la operación en lugar de cobrárselo al cliente.",
  account_coloca_treasury: "Tesorería de Coloca",
  account_coloca_treasury_hint:
    "Fondos propios de Coloca, ya en un proveedor, acreditados a clientes por el equipo. Se concilia contra los saldos reales de los proveedores.",
  account_unknown_badge: "Cuenta no catalogada",
  account_type_asset: "Activo",
  account_type_liability: "Pasivo",
  account_type_revenue: "Ingreso",
  account_type_expense: "Gasto",
  account_type_suspense: "Transitoria",
  scope_global: "Global",
  scope_provider: "Cuenta de proveedor",
  scope_organization: "Organización",

  rollup_title: "Sumas y saldos por cuenta",
  rollup_description: "Cómo quedó cada cuenta después de toda la operación, reversiones incluidas.",
  th_net: "Neto",
  th_last_balance: "Saldo al cierre",
  net_side_debit: "Al débito",
  net_side_credit: "Al crédito",
  net_flat: "Sin efecto neto",

  trail_title: "Historial de estados",
  trail_description: "Cuándo decidió el motor cada cambio, para cruzarlo con los asientos.",
  trail_toggle_show: "Ver historial de estados",
  trail_toggle_hide: "Ocultar historial de estados",
  trail_empty: "Esta operación no registró cambios de estado.",
  trail_error: "No se pudo leer el historial de estados.",
  trail_initial: "Creación",
  trail_source_internal_api: "Panel interno",
  trail_source_provider_webhook: "Confirmación del proveedor",
  trail_source_system: "Automático",
  trail_reason: "Motivo",
};
